angular.module('ihestiaCommonDirectives')
/**
 * pusty kontroler stworzony dla tworzenia pośredniczącego scope
 * dzięki temu w ng-include możemy zastosować
 * @param  {[type]} ){}] [description]
 * @return {[type]}        [description]
 */
  .controller('emptyCtrl', [function(){}]); // NOSONAR